import placeholderImg1 from '../assets/bot-placeholder1.webp';
import placeholderImg2 from '../assets/bot-placeholder2.webp';
import placeholderImg3 from '../assets/bot-placeholder3.webp';
import placeholderImg4 from '../assets/bot-placeholder4.webp';
import placeholderImg5 from '../assets/bot-placeholder5.webp';
import placeholderImg6 from '../assets/bot-placeholder6.webp';
import placeholderImg7 from '../assets/bot-placeholder7.webp';
import placeholderImg8 from '../assets/bot-placeholder8.webp';
import placeholderImg9 from '../assets/bot-placeholder9.webp';
import placeholderImg10 from '../assets/bot-placeholder10.webp';
import placeholderImg11 from '../assets/bot-placeholder11.webp';
import placeholderImg13 from '../assets/bot-placeholder13.webp';
import placeholderImg14 from '../assets/bot-placeholder14.webp';
import placeholderImg17 from '../assets/bot-placeholder17.webp';
import placeholderImg18 from '../assets/bot-placeholder18.webp';
import placeholderImg19 from '../assets/bot-placeholder19.webp';
import placeholderImg20 from '../assets/bot-placeholder20.webp';
import placeholderImg21 from '../assets/bot-placeholder21.webp';
import placeholderImg22 from '../assets/bot-placeholder22.webp';
import placeholderImg23 from '../assets/bot-placeholder23.webp';
import placeholderImg24 from '../assets/bot-placeholder24.webp';
import placeholderImg25 from '../assets/bot-placeholder25.webp';
import placeholderImg26 from '../assets/bot-placeholder26.webp';
import placeholderImg28 from '../assets/bot-placeholder28.webp';
import placeholderImg29 from '../assets/bot-placeholder29.webp';
import placeholderImg30 from '../assets/bot-placeholder30.webp';
import placeholderImg31 from '../assets/bot-placeholder31.webp';
import placeholderImg33 from '../assets/bot-placeholder33.webp';
import placeholderImg36 from '../assets/bot-placeholder36.webp';
import InVideoFreeTrialImg from '../assets/InVideoFreeTrial.webp';
import InVideoFreeTrial2Img from '../assets/InVideoFreeTrial2.webp';
import trustygifVideo from '../assets/trustygif.mp4';

export const rawBots = [
  {
    title: "Scholar GPT",
    desc: "AI-powered academic research assistant for scholars and students.",
    image: placeholderImg4,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-kZ0eYXlJe-scholar-gpt",
    categories: ["Education", "Specialized Knowledge"]
  },
  {
    title: "VEED AI",
    desc: "VEED is the easiest way to create videos. Edit videos, add subtitles, and more.",
    image: placeholderImg18,
    free: true,
    openaiLink: "https://veed.cello.so/2KWVFnsJmFA",
    categories: ["Productivity", "Marketing"]
  },
  {
    title: "n8n - AI Workflow Automation",
    desc: "Build AI agents and automate workflows with the world's most popular open-source automation platform.",
    image: "/n8nai.webp",
    free: false,
    openaiLink: "https://n8n.partnerlinks.io/wjt1744jflsx",
    isAffiliate: true,
    categories: ["Productivity", "AI"],
    freeLabel: "Free Trial"
  },
  {
    title: "JSON Prompt Creator",
    desc: "Magical JSON Prompt Creator for Video Generation",
    image: placeholderImg36,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-688ba73b3ba88191885c9b7009839045-json-prompt-creator",
    categories: ["Productivity"]
  },
  
  {
    title: "VetGPT",
    desc: "Get general veterinary advice on animal health, nutrition, and behavior. Not a substitute for professional veterinary care.",
    image: placeholderImg28,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-ZR0aH16CQ-vetgpt",
    categories: ["Health & Wellness", "Specialized Knowledge"]
  },
  {
    title: "Paintr",
    desc: "Identify any exact color of paint in seconds!", 
    image: placeholderImg31,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-6833f9d3f1f88191ba83263ab7a99ea7-paintr",
    categories: ["Specialized Knowledge"] 
  },
  {
    title: "Health & Medicine",
    desc: "General health and wellness info powered by AI. Not a substitute for professional medical advice.",
    image: placeholderImg8,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-t3BUYjh4C-health-medicinenot-doctor-not-medical-advice",
    categories: ["Health & Wellness", "Education"]
  },
  {
    title: "Personal Assistant",
    desc: "Organize and optimize your daily life with this AI-powered personal assistant.",
    image: placeholderImg11,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-hWAjkwSzj-personal-assistant",
    categories: ["Productivity"]
  },
  
  {
    title: "Cooking, Diet, Recipes, Nutrition",
    desc: "Personalized recipes, diet plans, nutrition tips, and food cooking advice in one spot.",
    image: placeholderImg5,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-KU2U5o7Wj-cookingdietrecipesnutritionfood",
    categories: ["Health & Wellness", "Lifestyle"]
  },
  {
    title: "AdCreative.ai",
    desc: "Generate conversion-focused ad creatives, texts, photoshoots, and videos that outperform competitors.",
    image: "/SQUAREad.mp4",
    isVideo: true,
    free: false,
    openaiLink: "https://free-trial.adcreative.ai/BAIB",
    isAffiliate: true,
    categories: ["Creative Tools", "Productivity"],
    freeLabel: "Free Trial"
  },
  {
    title: "Fitness Workout Diet PhD Coach",
    desc: "AI-powered fitness, workout, and diet advice from a PhD-level virtual coach.",
    image: placeholderImg14,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-ipOIcM229-fitness-workout-diet-phd-coach",
    categories: ["Health & Wellness", "Lifestyle"]
  },
  {
    title: "Grammar Checker",
    desc: "Checks your grammar, spelling, and clarity with suggestions for better writing.",
    image: placeholderImg2,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-kfkNLRrwD-grammar-checker",
    categories: ["Productivity", "Education"]
  },
  {
    title: "Astrology Birth Chart GPT",
    desc: "Personalized astrological insights based on your birth date, time, and location.",
    image: placeholderImg30,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-WxckXARTP-astrology-birth-chart-gpt",
    categories: ["Specialized Knowledge", "Lifestyle"]
  },
  {
    title: "Academic Assistant Pro",
    desc: "Academic support, research help, citation, essay and study tools.",
    image: placeholderImg23,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-UubB08D4y-academic-assistant-pro",
    categories: ["Education"]
  },
  {
    title: "InVideo AI",
    desc: "The Future of Video Creation Is Here!",
    image: InVideoFreeTrialImg,
    rotatingImages: [InVideoFreeTrialImg, InVideoFreeTrial2Img],
    free: false,
    openaiLink: "https://invideo.sjv.io/c/6368097/2210623/12258",
    isAffiliate: true,
    affiliateHtml: `<a rel="sponsored" href="https://invideo.sjv.io/c/6368097/2210623/12258" target="_top" id="2210623"><img src="//a.impactradius-go.com/display-ad/12258-2210623" border="0" alt="" width="500" height="500"/></a><img height="0" width="0" src="https://imp.pxf.io/i/6368097/2210623/12258" style="position:absolute;visibility:hidden;" border="0" />`,
    categories: ["Creative Tools"],
    freeLabel: "Free Trial"
  },
  {
    title: "Math AI",
    desc: "Math solver and explainer: equations, word problems, and more.",
    image: placeholderImg33,
    free: true,
    openaiLink: "https://chatgpt.com/g/g-WP1diWHRl-math",
    categories: ["Education"]
  },
  {
    title: "GIF Generator",
    desc: "Quickly create custom GIFs on any topic or mood. Fun and easy to use.",
    image: trustygifVideo,
    isVideo: true,
    free: true,
    openaiLink: "https://chatgpt.com/share/68941477-0b54-8004-83c8-5cb27d26bf96",
    categories: ["Creative Tools"]
  }
];

// Placeholders for images
export const placeholderImgs = [
  placeholderImg1, placeholderImg2, placeholderImg3, placeholderImg4, placeholderImg5,
  placeholderImg6, placeholderImg7, placeholderImg8, placeholderImg9, placeholderImg10,
  placeholderImg11, placeholderImg13, placeholderImg14,
  placeholderImg17, placeholderImg18, placeholderImg19, placeholderImg20, 
  placeholderImg21, placeholderImg22, placeholderImg23, placeholderImg24, placeholderImg25, 
  placeholderImg26, placeholderImg28, placeholderImg29, placeholderImg30,
  placeholderImg31, placeholderImg33, 
];

// Shuffle utility for placeholders
export function shuffle(arr) {
  return arr.map(value => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
}

// Assign unique placeholder images for all bots that need them
export function assignBotImages(rawBots) {
  const botsNeedingImages = rawBots.filter(bot => !bot.image);
  let placeholders = shuffle([...placeholderImgs]);
  while (placeholders.length < botsNeedingImages.length) {
    placeholders = placeholders.concat(shuffle([...placeholderImgs]));
  }
  let idx = 0;
  return rawBots.map(bot => {
    if (bot.image) return bot;
    return { ...bot, image: placeholders[idx++] };
  });
}

export const bots = assignBotImages(rawBots); 
